export default "__VITE_ASSET__9IFmLwaI__"